export default __webpack_public_path__ + "static/KIM_ROY_WEB_BW_2-dc51e974174111d7a25149980b2cace2.jpg";